import { render, staticRenderFns } from "./FeedBackAddForm.vue?vue&type=template&id=2c34c24f&"
import script from "./FeedBackAddForm.vue?vue&type=script&lang=js&"
export * from "./FeedBackAddForm.vue?vue&type=script&lang=js&"
import style0 from "./FeedBackAddForm.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports